import { measureLatency } from '../../../gctl-measure';
import { NetworkError, deepCamelCase, searchQueryString } from '../../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type DeleteVideoPrivateCommentReactionFields = readonly string[];

/** Options for DELETE /videos/{video_id}/private_comments/{comment_id}/reactions/{reaction_id} */
export type DeleteVideoPrivateCommentReactionOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the video.
     */
    videoId: number;
    /**
     * The ID of the comment.
     */
    commentId: number;
    /**
     * The ID of the reaction.
     */
    reactionId: number;
  };

  /** Possible query parameters for /videos/{video_id}/private_comments/{comment_id}/reactions/{reaction_id} */
  query?: {
    /**
     * The password for the review link.
     */
    password?: string;

    /**
     * The ID of the review link used as context.
     */
    reviewId?: string;
  };
};

/** Result type for DELETE /videos/{video_id}/private_comments/{comment_id}/reactions/{reaction_id} */
export type DeleteVideoPrivateCommentReactionResult<Paths extends readonly string[]> = unknown;

/**
 * Delete a clip comment reaction
 * This method deletes the specified clip comment reaction. The authenticated user or guest user must be the owner of the reaction.
 */
export async function deleteVideoPrivateCommentReaction<
  Paths extends DeleteVideoPrivateCommentReactionFields,
>({
  baseUrl,
  where: { videoId, commentId, reactionId },
  query,
  ...options
}: DeleteVideoPrivateCommentReactionOptions<Paths>): Promise<
  DeleteVideoPrivateCommentReactionResult<Paths>
> {
  return measureLatency('deleteVideoPrivateCommentReaction', 'DELETE', async () => {
    let res = await fetch(
      `${baseUrl}/videos/${videoId}/private_comments/${commentId}/reactions/${reactionId}?${searchQueryString(
        query,
      )}`,
      {
        ...options,
        method: 'DELETE',
      },
    );

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as DeleteVideoPrivateCommentReactionResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
